<p-toast [autoZIndex]="false" [key]="toastKey.default"></p-toast>
<p-toast [autoZIndex]="false" [key]="toastKey.msal">
  <ng-template let-message #message>
    <span class="p-toast-message-icon pi pi-times-circle"></span>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail">
        {{ message.detail }} <br /><app-msal-login></app-msal-login>
      </div>
    </div>
  </ng-template>
</p-toast>
@if (user) {
  <app-header [user]="user"> </app-header>
}
<app-version-alert></app-version-alert>
<div [class.with-header]="user" class="app wrapper">
  @if (user) {
    <app-user-progress [user]="user"> </app-user-progress>
  }
  <main [@fadeInAnimation]="getState()" class="container">
    @if (user) {
      <app-notification-highlight> </app-notification-highlight>
    }
    <router-outlet #outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
